class PasswordModal extends DetailsModal {
  constructor() {
    super();

    if (this.querySelector('input[aria-invalid="true"]')) this.open({target: this.querySelector('details')});
  }
}

customElements.define('password-modal', PasswordModal);

document.addEventListener('DOMContentLoaded', function() {
  const timer = document.querySelector('.password-timer');
  if (!timer) return;
  
  const daysSpan = timer.querySelector('.password-timer__days');
  const hoursSpan = timer.querySelector('.password-timer__hours');
  const minutesSpan = timer.querySelector('.password-timer__minutes');
  const secondsSpan = timer.querySelector('.password-timer__seconds');

  const timeGoalSecs = Date.parse(timer.dataset.timeGoal) / 1000;
  var currentTimeSecs = Date.now() / 1000;
  var difference = timeGoalSecs - (Math.round(currentTimeSecs));

  updateTime();

  function updateTime() {
    // days
    const daysLeft = Math.floor(difference / 86400);
    const leftAfterDays = difference % 86400;
    daysSpan.innerHTML = returnNumberWithZero(daysLeft);
    // hours
    const hoursLeft = Math.floor(leftAfterDays / 3600);
    const leftAfterHours = leftAfterDays % 3600;
    hoursSpan.innerHTML = returnNumberWithZero(hoursLeft);
    // minutes
    const minutesLeft = Math.floor(leftAfterHours / 60);
    const leftAfterMinutes = leftAfterHours % 60;
    minutesSpan.innerHTML = returnNumberWithZero(minutesLeft);
    // seconds
    secondsSpan.innerHTML = returnNumberWithZero(leftAfterMinutes);

    difference -= 1;
  }

  function returnNumberWithZero(number) {
    return String(number).length === 1 ? "0" + number : number;
  }

  setInterval(updateTime, 1000);
})